import { makeActionCreatorObjParam } from '@trumedianetworks/tmn-core-components/src/util/redux-helpers';
import cloneDeep from 'lodash/cloneDeep';
import defaultsDeep from 'lodash/defaultsDeep';
import merge from 'lodash/merge';
import unset from 'lodash/unset';
import has from 'lodash/has';
import set from 'lodash/set';
import get from 'lodash/get';
import * as t from './action_types';
import { DETAIL_MODES, SOCCER_AUTH_DEFS } from '../../form/constants';
import { DELETION_MARK } from './constants';
import { apiAction } from '../../api/store/actions';
import { actions as notificationActions } from '../../notification';

import {
    siteValidationErrorsSelector,
    siteStagedEditsSelector,
    siteValidatedPathsSelector,
    selectedSiteDataSelector,
    getOverridePath,
    siteConfigTemplateSelector,
    selectedParentSiteSelector,
    siteSportSelector,
    defaultSiteDataSelector,
    siteDetailModeSelector,
} from './selectors';
import { flattenedKeys } from '../../util/object-helpers';
import { filterDataByTemplate } from '../../util/data-helpers';
const setSiteList = makeActionCreatorObjParam(t.SET_SITE_LIST, 'data');
const setLeagueData = makeActionCreatorObjParam(t.SET_LEAGUE_DATA, 'data');
const _setSport = makeActionCreatorObjParam(t.SET_SPORT, 'sport');
//const setSiteDetails = makeActionCreatorObjParam(t.SET_SITE_DETAILS, 'data');
export const setFilterDefsValue = makeActionCreatorObjParam(t.SET_FILTER_DEFS_VALUE, 'data');
const setStagedEditData = makeActionCreatorObjParam(t.SET_STAGED_EDITS, 'data');
const updateSiteDetails = makeActionCreatorObjParam(t.UPDATE_SITE_DETAILS, 'data');
const addSiteDetails = makeActionCreatorObjParam(t.ADD_SITE_DETAILS, 'data');
export const resetSiteData = makeActionCreatorObjParam(t.RESET_SITE_DATA);
//export const clearStagedEdits = makeActionCreatorObjParam(t.CLEAR_STAGED_EDITS);
export const clearValidationErrors = makeActionCreatorObjParam(t.CLEAR_VALIDATION_ERRORS);
export const setSiteDetailMode = makeActionCreatorObjParam(t.SET_DETAIL_MODE, 'mode');

export const _selectSite = makeActionCreatorObjParam(t.SELECT_SITE, 'name');
//const _unselectSite = makeActionCreatorObjParam(t.UNSELECT_SITE, 'name');

export const selectAllSites = makeActionCreatorObjParam(t.SELECT_ALL_SITES);
export const unselectAllSites = makeActionCreatorObjParam(t.UNSELECT_ALL_SITES);

export const setParentSite = makeActionCreatorObjParam(t.SET_PARENT_SITE, 'parentSite');
export const unsetParentSite = makeActionCreatorObjParam(t.UNSET_PARENT_SITE);

const setValidationErrors = makeActionCreatorObjParam(t.SET_VALIDATION_ERRORS, 'errors');
const setValidatedPaths = makeActionCreatorObjParam(t.SET_VALIDATED_PATHS, 'validatedPaths');
const setIsSaving = makeActionCreatorObjParam(t.SET_IS_SAVING, 'isSaving');

const setSiteTokens = makeActionCreatorObjParam(t.SET_SITE_TOKENS, 'tokens');
export const clearSiteTokens = makeActionCreatorObjParam(t.CLEAR_SITE_TOKENS);

export const setSiteHistory = makeActionCreatorObjParam(t.SET_SITE_HISTORY, 'siteHistory');
export const clearSiteHistory = makeActionCreatorObjParam(t.CLEAR_SITE_HISTORY);
export const setSiteHistoryIsLoading = makeActionCreatorObjParam(
    t.SET_SITE_HISTORY_IS_LOADING,
    'isLoading'
);

const setTemplateListIsLoading = makeActionCreatorObjParam(
    t.SET_TEMPLATE_LIST_IS_LOADING,
    'isLoading'
);

export const setSport = (data) => (dispatch, getState) => {
    const { site } = getState();
    const currentSport = site.sport;
    // todo: should we do this another way?
    if (data.sport !== currentSport) {
        dispatch(_setSport(data));
        // only do these if we're actually changing not just setting for the first time?
        //if (currentSport) {
        dispatch(fetchSiteList());
        dispatch(fetchLeagueData());
        //}
    }
};

const setSiteConfigTemplates = makeActionCreatorObjParam(t.SET_SITE_CONFIG_TEMPLATES, 'templates');

export const fetchSiteConfigTemplates = () => (dispatch, getState) => {
    dispatch(setTemplateListIsLoading({ isLoading: true }));
    dispatch(
        apiAction({
            url: '/v2/api/site-admin/site-config-templates',
            method: 'POST',
            data: {},
            onSuccess: (templates) => setSiteConfigTemplates({ templates }),
            onFailure: () => {
                console.log('Error occured fetching site config templates');
            },
            label: t.FETCH_SITE_CONFIG_TEMPLATES,
        })
    );
};

export const setStagedEdits = ({ data }) => {
    if (data) {
        const clonedData = cloneDeep(data);
        return setStagedEditData({ data: clonedData });
    }
    return setStagedEditData({ data: null });
};

export const setStagedEditByPath = (path, value) => (dispatch, getState) => {
    const state = getState();
    const stagedEdits = siteStagedEditsSelector(state);
    const currentValidationErrors = siteValidationErrorsSelector(state);
    const validatedPaths = siteValidatedPathsSelector(state);
    if (has(currentValidationErrors, path)) {
        const clonedErrors = cloneDeep(currentValidationErrors);
        unset(clonedErrors, path);
        dispatch(setValidationErrors({ errors: clonedErrors }));
    }
    if (validatedPaths.includes(path)) {
        const newValidatedPaths = validatedPaths.filter((p) => p !== path);
        dispatch(setValidatedPaths({ validatedPaths: newValidatedPaths }));
    }
    // not sure if we have to, but we could clear previously passed validations or errors here
    const clonedEdits = cloneDeep(stagedEdits);
    syncNameDerivedValues(path, value, clonedEdits);
    handleSideEffects(value, path, clonedEdits);
    set(clonedEdits, path, value);
    dispatch(setStagedEditData({ data: clonedEdits }));
};

// this is kind of a hack, if we rely on this more, we should build out to something more robust
function handleSideEffects(value, path, clonedEdits = {}) {
    if (clonedEdits?.sport === 'soccer') {
        const authDef = SOCCER_AUTH_DEFS.find(
            ({ siteLevelAuth }) => path === `authorizations.${siteLevelAuth}`
        );
        if (authDef) {
            if (value) {
                set(clonedEdits, `leagueData.${authDef.auth}.limitType`, 'NONE');
            } else {
                unset(clonedEdits, `leagueData.${authDef.auth}`);
            }
        }
    }
}

// this autofills the domain/staging name/staging domain if they match the subdomain or are empty
function syncNameDerivedValues(path, value, clonedEdits) {
    if (path === 'core.name') {
        if (value) {
            const baseDomain = clonedEdits?.meta?.defaultDomain ?? 'trumedianetworks.com';
            const { domain, name } = clonedEdits?.core;
            const { name: stagingName, domain: stagingDomain } = clonedEdits?.staging;
            // in this case, the logic is simple, just combine the name and the baseDomain
            if (clonedEdits?.meta?.hasPathBasedSites) {
                // some of this logic is a little repetitive, could clean up
                //clonedEdits?.meta?.defaultDomain
                set(clonedEdits, 'core.domain', `${baseDomain}/${value}`);
                const stagingDomainParts = baseDomain.split('.');
                stagingDomainParts[0] = stagingDomainParts[0] + '-staging';
                const stagingDomain = stagingDomainParts.join('.');
                set(clonedEdits, 'staging.domain', `${stagingDomain}/${value}-staging`);
                if (!stagingName || stagingName.replace('-staging', '') === name) {
                    set(clonedEdits, 'staging.name', `${value}-staging`);
                }
            } else {
                // if the prior <name>-staging matches, then keep in sync
                if (!stagingName || stagingName.replace('-staging', '') === name) {
                    set(clonedEdits, 'staging.name', `${value}-staging`);
                }
                if (!domain || (domain.split('.')[0] === name && domain.includes(baseDomain))) {
                    set(clonedEdits, 'core.domain', `${value}.${baseDomain}`);
                }
                // sometimes we have 2 parts (tmn.com) and somtimes 3 (company.tmr.com)
                //const baseDomainParts = baseDomain.split('.');
                if (!stagingDomain || stagingDomain.replace('-staging', '') === domain) {
                    // if (baseDomainParts.length > 2) {
                    //     const stagingPart = baseDomainParts[0] + '-staging';
                    //     set(
                    //         clonedEdits,
                    //         'staging.domain',
                    //         `${value}.${stagingPart}.${baseDomainParts[1]}.${baseDomainParts[2]}`
                    //     );
                    // } else {
                    // we decided this was better anyway. always operate on the first segment
                    set(clonedEdits, 'staging.domain', `${value}-staging.${baseDomain}`);
                    //}
                }
            }
        } else {
            // this should only be hit if the user starts a name, then clears it out. Since name is readonly after create, this should be minimal impact
            // and help keep these in sync
            set(clonedEdits, 'staging.name', '');
            set(clonedEdits, 'core.domain', '');
            set(clonedEdits, 'staging.domain', '');
        }
    }
    if (path === 'staging.domain') {
        const baseDomain = clonedEdits?.meta?.defaultDomain ?? 'trumedianetworks.com';
        if (value) {
            if (clonedEdits?.meta?.hasPathBasedSites) {
                const stagingDomainParts = baseDomain.split('.');
                stagingDomainParts[0] = stagingDomainParts[0] + '-staging';
                const stagingDomain = stagingDomainParts.join('.');
                set(clonedEdits, 'staging.domain', `${stagingDomain}/${value}`);
            }
        } else {
            set(clonedEdits, 'staging.domain', '');
        }
    }
}

// todo maybe? update to something like this once we can fully work out how to handle child-staging.oval-staging.tmr.com
// function syncNameDerivedValues(path, value, clonedEdits) {
//     if (path === 'core.name' && value) {
//         const baseDomain = clonedEdits?.meta?.defaultDomain ?? 'trumedianetworks.com';
//         const { domain, name } = clonedEdits?.core;
//         const { name: stagingName, domain: stagingDomain } = clonedEdits?.staging;

//         // if the prior <name>-staging matches, then keep in sync
//         if (!stagingName || stagingName.replace('-staging', '') === name) {
//             set(clonedEdits, 'staging.name', `${value}-staging`);
//         }
//         if (!domain || (domain.split('.')[0] === name && domain.includes(baseDomain))) {
//             set(clonedEdits, 'core.domain', `${value}.${baseDomain}`);
//         }

//         const baseDomainParts = baseDomain.split('.');
//         const baseStagingDomain =
//             baseDomainParts.length > 2
//                 ? `${baseDomainParts[0]}-staging.${baseDomainParts[1]}.${baseDomainParts[2]}`
//                 : baseDomain;
//         if (
//             !stagingDomain ||
//             (stagingDomain.split('.')[0] === stagingName &&
//                 stagingDomain.includes(baseStagingDomain))
//         ) {
//             set(clonedEdits, 'staging.domain', `${value}-staging.${baseStagingDomain}`);
//         }
//     }
// }

// todo test this should be fine though
export const clearOverride = (path) => (dispatch, getState) => {
    const state = getState();
    const stagedEdits = siteStagedEditsSelector(state);
    const clonedEdits = cloneDeep(stagedEdits);
    const overridePath = getOverridePath(path);
    set(clonedEdits, overridePath, DELETION_MARK);
    dispatch(setStagedEditData({ data: clonedEdits }));
};

const clearSiteData = () => (dispatch, getState) => {
    dispatch(clearValidationErrors());
    dispatch(unselectAllSites());
    dispatch(setStagedEdits({ data: null }));
    //dispatch(setSiteDetails({ data: null }));
    dispatch(setValidatedPaths({ validatedPaths: null }));
    dispatch(clearSiteTokens());
    dispatch(clearSiteHistory());
    dispatch(setSiteHistoryIsLoading({ isLoading: false }));
};

const _validatePartialDetails = (partialSiteData, url) => (dispatch, getState) => {
    const sport = siteSportSelector(getState());
    dispatch(
        apiAction({
            url,
            method: 'POST',
            data: { sport, ...partialSiteData },
            onSuccess: ({ isValid, errors = {} }) => {
                const state = getState();
                const currentValidationErrors = siteValidationErrorsSelector(state) || {};
                // need to combine with previous errors OR clear previous matching errors
                // maybe tweak this so the partial validation can have some invalid and some valid
                // for now, only using for domain but in the future we'll likely have more
                // note we need to abstract as much as possible to share b/t users and sites
                if (!isValid && errors) {
                    // add errors, note merge mutates errors
                    merge(errors, currentValidationErrors);
                    dispatch(setValidationErrors({ errors }));
                }
                // on success we need to only clear or set the keys we were given in partialSiteData
                if (isValid) {
                    // remove errors for partialSiteData
                    const newErrors = cloneDeep(currentValidationErrors);
                    const validatedPaths = flattenedKeys(partialSiteData);
                    // todo here and possibly elsewhere, we need to remove the errors parent obj if all
                    // error sub keys have been cleared
                    unset(newErrors, validatedPaths);
                    dispatch(setValidationErrors({ errors: newErrors }));
                    dispatch(setValidatedPaths({ validatedPaths }));
                }
            },
            onFailure: () => {
                console.log('Error occured checking partial validation of site data');
            },
            label: t.VALIDATE_PARTIAL_SITE_DETAILS,
        })
    );
};

export const validatePartialDetails = (partialSiteData) => {
    return _validatePartialDetails(partialSiteData, '/v2/api/site-admin/site-validate-partial');
};

export const validateDomain = (partialSiteData) => {
    return _validatePartialDetails(partialSiteData, '/v2/api/site-admin/site-validate-domain');
};

export const updateDNS = (params) => (dispatch, getState) => {
    // on success we need to only clear or set the keys we were given in partialSiteData
    const state = getState();
    const siteData = selectedSiteDataSelector(state);
    const sport = siteSportSelector(state);
    const data = { ...params, sport };
    if (siteData.guid) {
        data.guid = siteData.guid;
    }

    dispatch(
        apiAction({
            url: '/v2/api/site-admin/site-update-dns',
            method: 'POST',
            data,
            onSuccess: ({ isValid, errors = {}, success, clientMessage, displayAsError }) => {
                if (isValid && success) {
                    dispatch(
                        notificationActions.showSnackbar({
                            snackbarMessage: `DNS updated`,
                            snackbarType: 'success',
                        })
                    );
                }
                if (!isValid) {
                    if (errors) {
                        // add errors, note merge mutates errors
                        const currentValidationErrors = siteValidationErrorsSelector(getState());
                        merge(errors, currentValidationErrors);
                        dispatch(setValidationErrors({ errors }));
                    }
                }
                if (!success) {
                    const snackbarMessage = clientMessage ?? 'Error updating DNS';
                    const snackbarType = displayAsError ? 'error' : 'info';
                    dispatch(
                        notificationActions.showSnackbar({
                            snackbarMessage,
                            snackbarType,
                        })
                    );
                }
            },
            onFailure: () => {
                console.log('Error occured updating site dns');
            },
            label: t.UPDATE_SITE_DNS,
        })
    );
};

// todo filter etc
export const fetchSiteList = () => (dispatch, getState) => {
    const sport = siteSportSelector(getState());
    const parentSite = selectedParentSiteSelector(getState());
    dispatch(
        apiAction({
            url: '/v2/api/site-admin/sites',
            method: 'POST',
            data: { sport, parentSite },
            onSuccess: (data) => setSiteList({ data }),
            onFailure: () => {
                console.log('Error occured fetching sitedata');
            },
            label: t.FETCH_SITE_LIST,
        })
    );
};

export const fetchLeagueData = () => (dispatch, getState) => {
    const sport = siteSportSelector(getState());
    const parentSite = selectedParentSiteSelector(getState());
    dispatch(
        apiAction({
            url: '/v2/api/site-admin/league-data',
            method: 'POST',
            data: { sport, parentSite },
            onSuccess: (data) => setLeagueData({ data }),
            onFailure: () => {
                console.log('Error occured fetching season');
            },
            label: t.FETCH_LEAGUE_DATA,
        })
    );
};

export const selectSite =
    ({ name }) =>
    (dispatch, getState) => {
        const detailMode = siteDetailModeSelector(getState());

        dispatch(clearSiteData());
        dispatch(_selectSite({ name }));

        if (detailMode === DETAIL_MODES.EDIT) {
            const siteData = selectedSiteDataSelector(getState());
            dispatch(refreshSiteData({ siteData }));
        }
    };
const refreshSiteData = (params) => (dispatch, getState) => {
    const { siteData } = params;
    const { guid, meta = {}, sport } = siteData;
    const { updated } = meta;
    const data = { guid, updated, sport };
    dispatch(
        apiAction({
            url: '/v2/api/site-admin/site-details',
            method: 'POST',
            data: data,
            onSuccess: (responseData) => {
                // todo hmm, else what? throw error
                const { siteData, isStale } = responseData;
                // isUpToDate
                if (isStale && siteData) {
                    dispatch(updateSiteDetails({ data: siteData }));
                }
            },

            onFailure: (err, data = {}) => {
                // todo go into view mode? slightly worried about going into a loop
                console.error('Error occured refreshing site', err, data);
                dispatch(
                    notificationActions.showSnackbar({
                        snackbarMessage: `Error refreshing site`,
                        snackbarType: 'error',
                    })
                );
            },
            label: t.FETCH_SITE,
        })
    );
};

export const editSiteDetails =
    ({ name }) =>
    (dispatch, getState) => {
        // note order here is important since select also does refresh
        // if we need more granular than that we can add a separate fn
        dispatch(setSiteDetailMode({ mode: DETAIL_MODES.EDIT }));
        dispatch(selectSite({ name }));
    };

export const viewSiteDetails =
    ({ name }) =>
    (dispatch, getState) => {
        dispatch(setSiteDetailMode({ mode: DETAIL_MODES.VIEW }));
        dispatch(selectSite({ name }));
    };

export const newSite = () => (dispatch, getState) => {
    // set parent site here?
    dispatch(clearSiteData());
    dispatch(setSiteDetailMode({ mode: DETAIL_MODES.NEW }));
};

export const unselectSite = () => (dispatch, getState) => {
    dispatch(clearSiteData());
    dispatch(setSiteDetailMode({ mode: DETAIL_MODES.VIEW }));
};

export const copySite =
    ({ siteData }) =>
    (dispatch, getState) => {
        const copySiteData = {
            ...siteData,
            staging: {},
            core: {},
            guid: null,
            settings: { ...siteData.settings, schemaName: null },
        };
        if (siteData?.meta?.parentSite) {
            copySiteData.dpConfig.credentials = {};
        }

        const parentSite = siteData?.meta?.parentSite;
        if (parentSite) {
            // for child sites, we want to null out the creds so they can be autogenerated
            copySiteData.dpConfig.credentials = {};
            dispatch(setParentSite({ parentSite, sport: siteData?.sport }));
        }
        // fill in defaults for anything we cleared in copySiteData
        const defaultSiteData = defaultSiteDataSelector(getState());
        const newSiteData = defaultsDeep(copySiteData, defaultSiteData);
        dispatch(clearSiteData());
        dispatch(setStagedEdits({ data: newSiteData }));
        dispatch(setSiteDetailMode({ mode: DETAIL_MODES.NEW }));
    };

export const addSite = (params) => (dispatch, getState) => {
    const { data } = params;
    const sport = siteSportSelector(getState());
    const siteTemplate = siteConfigTemplateSelector(getState()) || {};
    const filteredData = filterDataByTemplate(siteTemplate, data);
    const addNewData = { ...filteredData, sport };
    const parentSite = selectedParentSiteSelector(getState());
    if (parentSite) {
        // addNewData.core.security.authentication.parentSite = parentSite;
        // addNewData.staging.security.authentication.parentSite = parentSite;
        addNewData.meta.parentSite = parentSite;
    }
    dispatch(setIsSaving({ isSaving: true }));
    dispatch(
        apiAction({
            url: '/v2/api/site-admin/site-add',
            method: 'POST',
            data: addNewData,
            onSuccess: (responseData) => {
                const { siteData } = responseData;
                if (siteData) {
                    dispatch(
                        notificationActions.showSnackbar({
                            snackbarMessage: `Site added.`,
                            snackbarType: 'success',
                        })
                    );
                    handleSiteAddSuccess(dispatch, getState, siteData);
                }
                dispatch(setIsSaving({ isSaving: false }));
            },
            onFailure: (err, data = {}) => {
                const { validationFailed, errors } = data;
                dispatch(setIsSaving({ isSaving: false }));
                if (validationFailed && errors) {
                    dispatch(setValidationErrors({ errors }));
                }
                console.error('Error occured adding new site', err, data);
                dispatch(
                    notificationActions.showSnackbar({
                        snackbarMessage: `Error adding new site`,
                        snackbarType: 'error',
                    })
                );
            },
            label: t.ADD_SITE_DETAILS,
        })
    );
};

export const saveSite = (params) => (dispatch, getState) => {
    const { data } = params;
    const { guid } = data;
    const siteTemplate = siteConfigTemplateSelector(getState()) || {};
    const filteredData = filterDataByTemplate(siteTemplate, data);
    const editData = { ...filteredData, guid };

    dispatch(setIsSaving({ isSaving: true }));
    dispatch(
        apiAction({
            url: '/v2/api/site-admin/site-edit',
            method: 'POST',
            data: editData,
            onSuccess: (responseData) => {
                // todo hmm, else what? throw error
                const { siteData } = responseData;
                if (siteData) {
                    dispatch(
                        notificationActions.showSnackbar({
                            snackbarMessage: `Site edit successful.`,
                            snackbarType: 'success',
                        })
                    );
                    handleSiteEditSuccess(dispatch, siteData);
                }
                dispatch(setIsSaving({ isSaving: false }));
            },

            onFailure: (err, data = {}) => {
                const { validationFailed, errors } = data;
                if (validationFailed && errors) {
                    dispatch(setValidationErrors({ errors }));
                }
                dispatch(setIsSaving({ isSaving: false }));
                console.error('Error occured saving site', err, data);
                dispatch(
                    notificationActions.showSnackbar({
                        snackbarMessage: `Error saving site`,
                        snackbarType: 'error',
                    })
                );
            },
            label: t.EDIT_SITE_DETAILS,
        })
    );
};

export const activateSite = (data) => (dispatch, getState) => {
    dispatch(
        apiAction({
            url: '/v2/api/site-admin/site-activate',
            method: 'POST',
            data: data,
            onSuccess: (responseData) => {
                const { siteData } = responseData;
                if (siteData) {
                    dispatch(
                        notificationActions.showSnackbar({
                            snackbarMessage: `Activate site successful.`,
                            snackbarType: 'success',
                        })
                    );
                    handleSiteEditSuccess(dispatch, siteData);
                }
            },

            onFailure: (err, data = {}) => {
                console.error('Error occured activating site', err, data);
                dispatch(
                    notificationActions.showSnackbar({
                        snackbarMessage: `Error activating site`,
                        snackbarType: 'error',
                    })
                );
            },
            label: t.ACTIVATE_SITE,
        })
    );
};

export const deactivateSite = (data) => (dispatch, getState) => {
    dispatch(
        apiAction({
            url: '/v2/api/site-admin/site-deactivate',
            method: 'POST',
            data: data,
            onSuccess: (responseData) => {
                const { siteData } = responseData;
                if (siteData) {
                    dispatch(
                        notificationActions.showSnackbar({
                            snackbarMessage: `Deactivate site successful.`,
                            snackbarType: 'success',
                        })
                    );
                    handleSiteEditSuccess(dispatch, siteData);
                }
            },

            onFailure: (err, data = {}) => {
                console.error('Error occured activating site', err, data);
                dispatch(
                    notificationActions.showSnackbar({
                        snackbarMessage: `Error deactivating site`,
                        snackbarType: 'error',
                    })
                );
            },
            label: t.DEACTIVATE_SITE,
        })
    );
};

export const softDeactivateSite = (data) => (dispatch, getState) => {
    dispatch(
        apiAction({
            url: '/v2/api/site-admin/site-soft-deactivate',
            method: 'POST',
            data: data,
            onSuccess: (responseData) => {
                const { siteData } = responseData;
                if (siteData) {
                    dispatch(
                        notificationActions.showSnackbar({
                            snackbarMessage: `Soft deactivate site successful.`,
                            snackbarType: 'success',
                        })
                    );
                    handleSiteEditSuccess(dispatch, siteData);
                }
            },

            onFailure: (err, data = {}) => {
                console.error('Error occured deactivating site', err, data);
                dispatch(
                    notificationActions.showSnackbar({
                        snackbarMessage: `Error deactivating site`,
                        snackbarType: 'error',
                    })
                );
            },
            label: t.DEACTIVATE_SITE,
        })
    );
};

export const softActivateSite = (data) => (dispatch, getState) => {
    dispatch(
        apiAction({
            url: '/v2/api/site-admin/site-soft-activate',
            method: 'POST',
            data: data,
            onSuccess: (responseData) => {
                const { siteData } = responseData;
                if (siteData) {
                    dispatch(
                        notificationActions.showSnackbar({
                            snackbarMessage: `Soft reactivate site successful.`,
                            snackbarType: 'success',
                        })
                    );
                    handleSiteEditSuccess(dispatch, siteData);
                }
            },

            onFailure: (err, data = {}) => {
                console.error('Error occured reactivating site', err, data);
                dispatch(
                    notificationActions.showSnackbar({
                        snackbarMessage: `Error reactivating site`,
                        snackbarType: 'error',
                    })
                );
            },
            label: t.SOFT_ACTIVATE_SITE,
        })
    );
};

function handleSiteEditSuccess(dispatch, siteData) {
    dispatch(setStagedEdits({ data: null }));
    dispatch(clearValidationErrors());
    dispatch(updateSiteDetails({ data: siteData }));
    dispatch(setSiteDetailMode({ mode: DETAIL_MODES.VIEW }));
    dispatch(
        fetchSiteHistory({
            guid: siteData.guid,
            sport: siteData.sport,
        })
    );
}

function handleSiteAddSuccess(dispatch, getState, siteData) {
    //dispatch(clearSiteData());
    dispatch(addSiteDetails({ data: siteData }));
    dispatch(viewSiteDetails({ name: siteData?.core?.name }));
    // select site
    // changing this behavior since sites are more complicated and will probably not be added rapid fire like users might
    // this differs from edit in that we make no change to the mode so that
    // more sites can be added easily
}

export const fetchSiteHistory =
    ({ guid, sport }) =>
    (dispatch, getState) => {
        const params = { guid, sport };
        dispatch(setSiteHistoryIsLoading({ isLoading: true }));
        dispatch(clearSiteHistory());
        dispatch(
            apiAction({
                url: '/v2/api/site-admin/site-history',
                method: 'POST',
                data: params,
                onSuccess: ({ siteHistory = [] } = {}) => {
                    const siteData = selectedSiteDataSelector(getState());
                    if (guid === siteData?.guid) {
                        dispatch(setSiteHistory({ siteHistory }));
                    }
                    dispatch(setSiteHistoryIsLoading({ isLoading: false }));
                },
                onFailure: (err, data = {}) => {
                    console.error('error fetching site history', err);
                    dispatch(setSiteHistoryIsLoading({ isLoading: false }));
                },
                label: t.FETCH_SITE_HISTORY,
            })
        );
    };

export const fetchSiteTokens =
    ({ guid }) =>
    (dispatch, getState) => {
        // cleanup
        const params = { guid };

        dispatch(
            apiAction({
                url: '/v2/api/site-admin/site-tokens-list',
                method: 'POST',
                data: params,
                onSuccess: ({ tokens = [] } = {}) => {
                    // only set the tokens IF the site currently selected matches the original request
                    // this ought to prevent getting out of sync
                    const siteData = selectedSiteDataSelector(getState());
                    if (guid === siteData?.guid) {
                        dispatch(setSiteTokens({ tokens }));
                    }
                },
                onFailure: (err, data = {}) => {
                    console.error('error fetching user devices', err);
                },
                label: t.FETCH_SITE_TOKENS,
            })
        );
    };

export const generateNewSiteToken =
    ({ guid }) =>
    (dispatch, getState) => {
        const params = { guid };
        dispatch(
            apiAction({
                url: '/v2/api/site-admin/site-token-create',
                method: 'POST',
                data: params,
                onSuccess: (responseData) => {
                    const { success } = responseData;
                    if (success) {
                        dispatch(
                            notificationActions.showSnackbar({
                                snackbarMessage: `Site token created.`,
                                snackbarType: 'success',
                            })
                        );
                        dispatch(fetchSiteTokens({ guid }));
                        // const siteData = selectedSiteDataSelector(getState());
                        // if (params.guid === siteData?.guid) {
                        //     dispatch(setSiteTokens({ tokens }));
                        // }
                    }
                },
                onFailure: (err, data = {}) => {
                    console.log(err);
                },
                label: t.GENERATE_SITE_TOKEN,
            })
        );
    };

export const saveSiteToken =
    ({ guid, token, expiration_date }) =>
    (dispatch, getState) => {
        const params = { guid, token, expiration_date };
        dispatch(
            apiAction({
                url: '/v2/api/site-admin/site-token-edit',
                method: 'POST',
                data: params,
                onSuccess: (responseData) => {
                    const { success } = responseData;
                    if (success) {
                        dispatch(
                            notificationActions.showSnackbar({
                                snackbarMessage: `Site token updated.`,
                                snackbarType: 'success',
                            })
                        );
                        dispatch(fetchSiteTokens({ guid }));
                    }
                },
                onFailure: (err, data = {}) => {
                    console.log(err);
                },
                label: t.EDIT_SITE_TOKEN,
            })
        );
    };
